import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

const useGetShareLinks = () => {
  const projectId = useGetCurrentProjectId();
  return projectApi.useGetProjectsByProjectIdShareLinksQuery(
    {
      projectId: projectId!,
    },
    { skip: !projectId },
  );
};

export default useGetShareLinks;
